import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Only log this error once during initialization, not on every fetch attempt
if (!supabaseUrl || !supabaseAnonKey) {
  console.log(
    "Supabase URL or Anonymous Key is missing. Using fallback configuration for development.",
  );
}

// Create client with error handling for network issues
const createClientWithErrorHandling = () => {
  try {
    return createClient(supabaseUrl || "", supabaseAnonKey || "", {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  } catch (error) {
    console.error("Error creating Supabase client:", error);
    throw error; // Let the error propagate to be handled by the application
  }
};

export const supabase = createClientWithErrorHandling();
